<template>
  <div>
    <Nav className="navbar navbar-default navbar-mobile navbar-fixed light bootsnav" />
    <JobBanner :title="job.title.name" :desc="job.company_desc ? job.company_desc : job.client_company.name.name" />
    <JobDetail :job="job" :jobs="jobs" />
    <Footer />
    <FollowModal />
    <ApplyModal :jobId="this.jobId" />
    <SubscribeModal />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import JobBanner from '@/components/JobBanner.vue'
import JobDetail from '@/components/JobDetail.vue'
import Footer from '@/components/Footer.vue'
import FollowModal from '@/components/FollowModal.vue'
import ApplyModal from '@/components/ApplyModal.vue'
import SubscribeModal from '@/components/SubscribeModal.vue'

export default {
  name: 'detail',
  components: {
    Nav,
    JobBanner,
    JobDetail,
    Footer,
    FollowModal,
    ApplyModal,
    SubscribeModal
  },
  data: () => ({
	  jobs: [],
	  job: {}
  }),
  watch: {
    jobId: function() {
      this.updateJob()
    }
  },
  computed: {
    jobId: function() {
      return this.$route.params.id
    },
    isHR: function() {
      return this.$route.query.s === '1'
    }
  },
  methods: {
    updateJob: function() {
      let that = this,
        url = this.isHR ? this.API_PREFIX + '/api2/job/' : this.API_PREFIX + '/api/job/',
        url1 = this.isHR ? this.API_PREFIX + '/api2/search/job' : this.API_PREFIX + '/api/search/job'

      this.$http.get(url + this.jobId).then(function (response) {
        //console.log(response)
        that.job = response.data
        that.normalizeName(that.job.title)
        if(that.job.client_company)
          that.normalizeCompany(that.job.client_company.name)

        let functionId = that.job.job_function.function_group_id
        let filter = {
          options: {
            page: 0,
            size: 9,
            sort: [{ id: 'desc' }]
          },
          query: {
            mandatory_filters: [{"type":"must","filter":{"or":[{"term":{"status":0}},{"term":{"status":1}}]}}],
            optional_filters:[{"boost":9,
             "filter":{"query":{"query_string":{"query": encodeURI(that.job.title.name)
             }}}}]
          }
        }
        filter.query.mandatory_filters.push({
          type: 'must',
          filter: {
            or: [
              { term: { 'job_function.id': functionId }},
              { term: { 'job_function.function_id': functionId }},
              { term: { 'job_function.function_group_id': functionId }}
            ]
          }
        })

        that.$http.post(url1, filter).then(function (response) {
          console.log(response.data.hits)
          that.jobs = response.data.hits
          that.jobs.forEach(function(job, i) {
              that.normalizeName(job.data.title)
              if(job.data.recruiting_company)
                that.normalizeCompany(job.data.recruiting_company.name)
          })
        }).catch(function (error) {
          console.log(error)
        });
        
      }).catch(function (error) {
        console.log(error)
      });
    }
  },
  created: function() {
  	this.updateJob()
  }
}
</script>